import {useNavigate} from 'react-router-dom'
import {KTIcon} from '../../../../../_metronic/helpers'
import useAuthorization from '../../../../../hooks/useAuthorization'
import {useState} from 'react'
import {ReviewSalesModalForm} from '../../../components/ReviewSalesModalForm'
import {ISelect} from '../../../../../coreGlobal/models/default'
import {UserRequest} from '../../../../../coreGlobal/models/user'
import {getSaleApprovers, getUsers} from '../../../core/_resquest'
import {useAuth} from '../../../../../app/modules/auth'
import Swal from 'sweetalert2'

const ListToolbar = () => {
  const navigate = useNavigate()
  const handleToCreate = () => navigate('/users/list/create')

  const isAuthorizedToCreate = useAuthorization('users.create')
  const isAuthorizedToCreateUserApprovers = useAuthorization('franchises.sale_approvers')

  const [showSalesModal, setShowSalesModal] = useState<boolean>(false)

  const {currentFranchise} = useAuth()

  const [users, setUsers] = useState<ISelect[]>([])
  const [oldUser, setOldUser] = useState<UserRequest[]>([])

  const handleToUserApprovers = async () => {
    try {
      Swal.fire({
        title: 'Carregando...',
        text: 'Aguarde enquanto processamos sua solicitação.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      const [saleApprovers, data] = await Promise.all([
        getSaleApprovers(currentFranchise?.id),
        getUsers(),
      ])

      setOldUser(saleApprovers)

      const usersFiltered = data.filter(
        (user) => !saleApprovers.some((old) => Number(old.id) === Number(user.value))
      )

      setUsers(usersFiltered)

      Swal.close()

      setShowSalesModal(true)
    } catch (error: any) {
      if (error.response?.status === 422) {
        let errorText = ''

        for (const key in error.response.data.errors) {
          errorText += `<li>${error.response.data.errors[key][0]}</li>`
        }

        await Swal.fire({
          icon: 'error',
          title: 'Ops! Revise seu formulário e tente novamente!',
          html: errorText,
        })
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.message ?? 'Ocorreu um erro inesperado.',
          timer: 2000,
        })
      }
      Swal.close()
    }
  }

  return (
    <>
      <div className='d-flex justify-content-end gap-3' data-kt-user-table-toolbar='base'>
        {/* begin::Add user */}
        {isAuthorizedToCreateUserApprovers && (
          <button type='button' className='btn btn-light-danger' onClick={handleToUserApprovers}>
            <KTIcon iconName='plus' className='fs-2' />
            Adicionar Aprovadores
          </button>
        )}

        {isAuthorizedToCreate && (
          <button type='button' className='btn btn-light-danger' onClick={handleToCreate}>
            <KTIcon iconName='plus' className='fs-2' />
            Adicionar Usuário
          </button>
        )}
        {/* end::Add user */}
      </div>

      {showSalesModal && (
        <ReviewSalesModalForm
          oldUser={oldUser}
          setOldUser={setOldUser}
          users={users}
          setUsers={setUsers}
          close={() => setShowSalesModal(false)}
        />
      )}
    </>
  )
}

export {ListToolbar}
